import React, { useState, forwardRef } from "react";
import styled, { css } from "styled-components";
import { Theme } from "../../../theme";
import {
  AppBar,
  Toolbar,
  Hidden,
  IconButton,
  Badge,
  Drawer,
  Divider,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import InputIcon from "@material-ui/icons/Input";

import { List, ListItem, Button, colors } from "@material-ui/core";

const StyledSection = styled.section`
  ${({ theme }: { theme: Theme }) => {
    return css`
      width: 240px;
      .root {
      }
      .item {
        display: flex;
        padding-top: 0;
        padding-bottom: 0;
      }
      .button {
        color: ${colors.blueGrey[800]};
        padding: 10px 8px;
        justify-content: flex-start;
        text-transform: none;
        letter-spacing: 0px;
        width: 100%;
        font-weight: ${theme.typography.fontWeightMedium};
      }
      .icon {
        /* Change this later */
        color: ${theme.palette.primary.dark};
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        margin-right: ${theme.spacing(1)}px;
      }
      .active {
        color: ${theme.palette.primary.main};
        font-weight: ${theme.typography.fontWeightMedium};
        & .icon {
          color: ${theme.palette.primary.main};
        }
      }
    `;
  }};
`;

type CustomRouterProps = {
  to: string;
  className: string;
  activeClassName: string;
};
const CustomRouterLink = forwardRef<
  NavLink,
  Omit<CustomRouterProps, "forwardedRef">
>((props, ref) => (
  <div ref={ref as React.Ref<any>} style={{ flexGrow: 1 }}>
    <NavLink {...props} />
  </div>
));

export interface SidebarProps {
  onLogoutOpen: () => void;
  pages: { title: string; href: string; icon: JSX.Element }[];
  [key: string]: any;
}

const Sidebar: React.FC<SidebarProps> = props => {
  const { pages, className, ...rest } = props;

  const theme: Theme = useTheme();

  return (
    <>
      <StyledSection theme={theme}>
        <List {...rest} className={clsx("root", className)}>
          {pages.map(page => (
            <ListItem className="item" disableGutters key={page.title}>
              {/*
 // @ts-ignore */}
              <Button
                activeClassName="active"
                className="button"
                component={CustomRouterLink}
                to={page.href}
              >
                <div className="icon">{page.icon}</div>
                {page.title}
              </Button>
            </ListItem>
          ))}
          {/* LOGOUT BUTTON */}
          <ListItem className="item" disableGutters key="Logout">
            {/*
 // @ts-ignore */}
            <Button
              activeClassName="active"
              className="button"
              component={CustomRouterLink}
              onClick={props.onLogoutOpen}
            >
              <div className="icon">
                {" "}
                <InputIcon />
              </div>
              Logout
            </Button>
          </ListItem>
        </List>
      </StyledSection>
    </>
  );
};

export default Sidebar;
